import React, { useRef } from "react";
import PropTypes from "prop-types";
// import TextField from '@material-ui/core/TextField';
import TextField from '@mui/material/TextField';
import { InputLabel, Paper, Tooltip } from "@mui/material";


const styles = {
    textField: {
        fontFamily: "Customfont !important"
    }
}


export default function CustomInput(props) {
    const { label, id, defaultValue, helperText, inputType, tabIndex, placeholder, readonly } = props


    const [state, setState] = React.useState({
        onChange: false,
        inputData: defaultValue || ""
    });
    React.useEffect(async () => {
        console.log("defaultValue", defaultValue)
        await setState(prevState => ({ ...prevState, inputData: defaultValue || "", onChange: false }))

        return () => {
        }
    }, [defaultValue])

    // React.useEffect(() => {
    //     try {
    //         if (state.onChange === true) {
    //           //  props.resData(state.inputData)
    //             setState(prevState => ({ ...prevState, onChange: false }))
    //         }
    //     } catch (error) {
    //         console.log("cate props input")
    //     }
    //     return () => {
    //     }
    // }, [state.inputData, state.onChange])

    const handleChange = (event) => {
        // event.preventDefault(); 
        //console.log("handleChange", event.target.value);
        setState(prevState => ({ ...prevState, inputData: event.target.value, onChange: true }))
        // try {
        //     props.resData(event.target.value)
        // } catch (error) {
        // }
    }
    const onBlur = (event) => {
        try {
            props.resData(event.target.value)
        } catch (error) {

        }

    }
    const handleKeyDown = (event) => {
        // event.preventDefault(); 
        try {
            //     if (event.key === "Enter") {
            props.keyDown(event.key)
        }
        catch (error) {
            console.log("keyDown ", error);
        }
    }
    return (
        <>
            <div style={{
                display: 'flex',
                alignItems: 'stretch',
                width: '100%',
                border: '1px solid #ccc',
                borderRadius: '4px',
                overflow: 'hidden',
                minHeight: '30px',
                height: '30px',
                margin: 0
            }}>
                <Tooltip title={label}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#eee',
                        borderRight: '1px solid #ccc',
                        padding: '6px 12px',
                        minWidth: '120px',
                        maxWidth: '180px',
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                        fontSize: '14px',
                        fontFamily: 'Customfont',
                        color: '#555',
                        fontWeight: '600',
                        lineHeight: '1.42857143',
                        height: '30px'
                    }}>
                        {label}
                    </div>
                </Tooltip>

                <TextField
                    sx={{
                        flex: 1,
                        backgroundColor: "#fff",
                        fontFamily: "Customfont",
                        '& .MuiInput-root': {
                            '&:before': {
                                borderBottom: 'none'
                            },
                            '&:hover:not(.Mui-disabled):before': {
                                borderBottom: 'none'
                            },
                            '&:after': {
                                borderBottom: 'none'
                            }
                        },
                        '& .MuiInputBase-input': {
                            padding: '6px 12px',
                            fontSize: '14px',
                            fontFamily: 'Customfont'
                        }
                    }}
                    hiddenLabel
                    id={id}
                    onChange={handleChange}
                    value={state.inputData || ""}
                    helperText={helperText}
                    variant="standard"
                    size="small"
                    type={inputType}
                    fullWidth
                    tabIndex={tabIndex}
                    placeholder={placeholder}
                    onBlur={e => onBlur(e)}
                    onKeyDown={handleKeyDown}
                    disabled={readonly}
                />
            </div>
        </>
    );
}
CustomInput.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    defaultValue: PropTypes.string,
    helperText: PropTypes.string,
    inputType: PropTypes.oneOf(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "email", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time-local", "url", "file", "week"]),
    placeholder: PropTypes.string,
    tabIndex: PropTypes.number,
    readonly: PropTypes.bool
}
CustomInput.defaultProps = {
    readonly: false
}
